import { render } from "./email-page.vue?vue&type=template&id=3762ca7c&scoped=true"
import script from "./email-page.vue?vue&type=script&lang=js"
export * from "./email-page.vue?vue&type=script&lang=js"

import "./email-page.vue?vue&type=style&index=0&id=3762ca7c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3762ca7c"]])

export default __exports__